import SidebarMenu from "./sidebar-menu";
import Model from "./model";
import CategoryLevel from "./category-level";
import ListColumnWidth from "./list-column-width";
import OrderAction from "./order-action";
import Type from "./type";

// 基础地址
const BaseUrl = "https://api.ytxgsmm.cn";
// const BaseUrl = "http://localhost:3002";

// CDN
const CdnUrl = "https://ytxlyj-gs.lrcdn.cn";

// 接口地址
const ApiUrl = BaseUrl + "/admin";

// 公开接口地址
const PublicApiUrl = BaseUrl + "/public";

// 分页大小
const PageSize = 10;

// 网站标题
const Title = "网站后台";

export default {
  SidebarMenu,
  Model,
  CategoryLevel,
  ListColumnWidth,
  OrderAction,
  Type,
  BaseUrl,
  CdnUrl,
  ApiUrl,
  PublicApiUrl,
  PageSize,
  Title
};
